export const isDev = () => {
    const host = window.location.host;
    return host.includes("dev") || host.includes("localhost");
};